/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BytesLike,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Whitelist, WhitelistInterface } from "../Whitelist";

const _abi = [
  {
    inputs: [
      {
        internalType: "address[]",
        name: "operators",
        type: "address[]",
      },
      {
        internalType: "bytes4[][]",
        name: "targets",
        type: "bytes4[][]",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type WhitelistConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WhitelistConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Whitelist__factory extends ContractFactory {
  constructor(...args: WhitelistConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Whitelist";
  }

  deploy(
    operators: string[],
    targets: BytesLike[][],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Whitelist> {
    return super.deploy(
      operators,
      targets,
      overrides || {}
    ) as Promise<Whitelist>;
  }
  getDeployTransaction(
    operators: string[],
    targets: BytesLike[][],
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(operators, targets, overrides || {});
  }
  attach(address: string): Whitelist {
    return super.attach(address) as Whitelist;
  }
  connect(signer: Signer): Whitelist__factory {
    return super.connect(signer) as Whitelist__factory;
  }
  static readonly contractName: "Whitelist";
  public readonly contractName: "Whitelist";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WhitelistInterface {
    return new utils.Interface(_abi) as WhitelistInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Whitelist {
    return new Contract(address, _abi, signerOrProvider) as Whitelist;
  }
}
